
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IDocument, IEmployeeOrgChartViewModel, IMetadataAction, IOrgChartEditNodeViewModel } from "@tylertech/tyler-api-types";

/**
 * OrgChartService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class OrgChartService<T = unknown> {
    private readonly $apiService = inject(ApiService);
    
    ExpandOrgChart(existingChart: IEmployeeOrgChartViewModel): Promise<IEmployeeOrgChartViewModel> {
        return this.$apiService.sendAuth("IOrgChartService/ExpandOrgChart", existingChart);
    }
    SaveCard(selectedCard: IOrgChartEditNodeViewModel): Promise<IMetadataAction> {
        return this.$apiService.sendAuth("IOrgChartService/SaveCard", selectedCard);
    }
    ShareCard(selectedCard: IEmployeeOrgChartViewModel): Promise<IDocument> {
        return this.$apiService.sendAuth("IOrgChartService/ShareCard", selectedCard);
    }
    ShowEditCardAction(selectedCard: IEmployeeOrgChartViewModel): Promise<IMetadataAction> {
        return this.$apiService.sendAuth("IOrgChartService/ShowEditCardAction", selectedCard);
    }
}
